import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  TemplateRef,
  Input,
  Injectable,
  PLATFORM_ID,
  Inject,
} from "@angular/core";
import { isPlatformBrowser } from "@angular/common";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { Router } from "@angular/router";
/**
 * @Bhushan services for initializing categoires and productitems list
 */
import { NaviFreshMartService } from "../../../services/navi-fresh-mart.service";
import { productitems } from "../../../../shared/classes/productitems";
import { category } from "../../../../shared/classes/category";
import { cart } from "src/app/shared/classes/cart";
import { SignUpComponent } from "src/app/pages/sign-up/sign-up.component";
@Component({
  selector: "app-checkout-modal",
  templateUrl: "./checkout-modal.component.html",
  styleUrls: ["./checkout-modal.component.scss"],
})
export class CheckoutModalComponent implements OnInit, OnDestroy {
  @ViewChild("checkoutModal", { static: false }) CheckoutModal: TemplateRef<
    any
  >;

  public closeResult: string;
  public modalOpen: boolean = false;
  public counter: number = 1;
  cartItems: productitems[];
  totalCartItems: productitems;
  user: any = {};
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router,
    private modalService: NgbModal,
    private productItemsService: NaviFreshMartService
  ) {
    this.user = localStorage.getItem("user"); 
    if (this.user) {
      this.cartItems = JSON.parse(localStorage.getItem("actcartItems"));
      this.totalCartItems = JSON.parse(localStorage.getItem("totalCartItems"));
    }
  }

  ngOnInit(): void {}

  openModal() {
    console.log(this.totalCartItems, this.cartItems);
    this.modalOpen = true;
    this.cartItems = JSON.parse(localStorage.getItem("actcartItems"));
    this.totalCartItems = JSON.parse(localStorage.getItem("totalCartItems"));
    if (isPlatformBrowser(this.platformId)) {
      // For SSR
      this.modalService
        .open(this.CheckoutModal, {
          ariaLabelledBy: "modal-basic-title",
          centered: true,
          size: "lg",
          windowClass: "Quickview",
        })
        .result.then(
          (result) => {
            `Result ${result}`;
          },
          (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
          }
        );
    }
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
  // Increament
  increment() {
    this.counter++;
  }

  // Decrement
  decrement() {
    if (this.counter > 1) this.counter--;
  }

  ngOnDestroy() {
    if (this.modalOpen) {
      this.modalService.dismissAll();
    }
  }
  // Increament
  cartincrement(selectedProduct: productitems) {
    this.counter++;
    /**
     * search product in cart items
     *  and increment
     */
    selectedProduct.itemCount = selectedProduct.itemCount + 1;
    selectedProduct.totalPrice =
      selectedProduct.itemCount * selectedProduct.offerPrice;

    const cartItem: cart = {};
    cartItem.cartId = 0;
    cartItem.itemQuantity = selectedProduct.itemCount;
    cartItem.prodId = selectedProduct.prodId;
    cartItem.accountId = this.user.accountId;
    cartItem.cartId = selectedProduct.cartId;
    cartItem.itemImgLoc = selectedProduct.itemImgLoc;
    cartItem.itemName = selectedProduct.prodName;
    this.productItemsService.postCartItem(cartItem).subscribe((data) => {
      this.updateTotalCartItems();
    });
  }

  // Decrement
  cartdecrement(selectedProduct: productitems) {
    // if (this.counter > 1) {
    //   this.counter--;
    // }
    /**
     * search product in cart items
     *  and increment
     */
    if (selectedProduct.itemCount > 0) {
      selectedProduct.itemCount = selectedProduct.itemCount - 1;
      selectedProduct.totalPrice =
        selectedProduct.itemCount * selectedProduct.offerPrice;
      const cartItem: cart = {};
      cartItem.cartId = 0;
      cartItem.itemQuantity = selectedProduct.itemCount;
      cartItem.prodId = selectedProduct.prodId;
      cartItem.accountId = this.user.accountId;
      cartItem.cartId = selectedProduct.cartId;
      cartItem.itemImgLoc = selectedProduct.itemImgLoc;
      cartItem.itemName = selectedProduct.prodName;
      if (selectedProduct.itemCount === 0) {
        this.productItemsService.deleteCartItem(cartItem).subscribe((data) => {
          // remove from cart
          const index = this.cartItems.findIndex(
            (item) => item.prodId === selectedProduct.prodId
          );
          if (index !== -1) {
            this.cartItems.splice(index, 1);
            localStorage.setItem(
              "actcartItems",
              JSON.stringify(this.cartItems)
            );
          }
          selectedProduct.isShown = false;
          this.updateTotalCartItems();
        });
      } else {
        this.productItemsService.postCartItem(cartItem).subscribe((data) => {
          this.updateTotalCartItems();
        });
      }
    }
  }
  updateTotalCartItems() {
    let totalCount = 0;
    let totalPrice = 0;
    this.cartItems?.forEach((item) => {
      totalCount += item.itemCount;
      totalPrice += item.totalPrice;
    });
    this.totalCartItems.itemCount = totalCount;
    this.totalCartItems.totalPrice = totalPrice;
    localStorage.setItem("totalCartItems", JSON.stringify(this.totalCartItems));
    localStorage.setItem('actcartItems', JSON.stringify(this.cartItems));
  }
  toggleShow(selectedProduct: productitems) {
    console.log("Selected Data:", selectedProduct);

    if (localStorage.getItem("user")) {
      // set isShown Property to true
      selectedProduct.isShown = true;
      selectedProduct.itemCount = 1;
      selectedProduct.totalPrice =
        selectedProduct.itemCount * selectedProduct.offerPrice;

      // add this product to cartitmes array
      this.cartItems.push(selectedProduct);
      localStorage.setItem("actcartItems", JSON.stringify(this.cartItems));
      const cartItem: cart = {};
      cartItem.cartId = selectedProduct.cartId;
      cartItem.itemQuantity = selectedProduct.itemCount;
      cartItem.prodId = selectedProduct.prodId;
      cartItem.accountId = this.user.accountId;
      this.productItemsService.postCartItem(cartItem).subscribe((data) => {
        selectedProduct.cartId = data?.cartId;
        this.updateTotalCartItems();
      });
    } else {
      const signUpModal = this.modalService.open(SignUpComponent, {
        ariaLabelledBy: "modal-basic-title",
      });
      signUpModal.componentInstance.actionEvent = "cart";
      // set isShown Property to true
      selectedProduct.isShown = true;
      selectedProduct.itemCount = 1;
      selectedProduct.totalPrice =
        selectedProduct.itemCount * selectedProduct.offerPrice;

      // add this product to cartitmes array
      this.cartItems?.push(selectedProduct);
      const cartItem: cart = {};
      cartItem.cartId = 0;
      cartItem.itemQuantity = selectedProduct.itemCount;
      cartItem.prodId = selectedProduct.prodId;
      cartItem.accountId = this.user.accountId;
      localStorage.setItem("payload", JSON.stringify(cartItem));
    }
  }
}
